<script setup>
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { formatearInputMoneda, formatDateForBackend } from "@/utils/helpers";

const props = defineProps({
  garantiasStore: { type: Object, required: true },
});

const { movimientosGarantias } = storeToRefs(props.garantiasStore);

const rows = computed(() =>
  Array.isArray(movimientosGarantias.value?.data)
    ? movimientosGarantias.value.data
    : []
);

const show = ref(false);
const toggle = () => (show.value = !show.value);

// Helpers de presentación
function sentidoClass(g) {
  // si está Rechazado, prima el rojo
  if (g?.estado === "Rechazado") return "text-danger";
  if (g?.estado === "Pendiente") return "text-warning";
  return g?.sentido === "salida" ? "text-danger" : "text-success";
}
function signo(g) {
  return g?.sentido === "salida" ? "-" : "";
}
function montoMostrado(g) {
  const val =
     Number(g?.monto || 0)
    
  return formatearInputMoneda(val);
}
function estadoBadgeClass(historialcomprobante) {
  let estado = getEstadoFromComprobante(historialcomprobante)
  switch (estado) {
    case "Aprobado":
      return "badge-soft success";
    case "Pendiente":
      return "badge-soft warning";
    case "Rechazado":
      return "badge-soft danger";
    default:
      return "badge-soft secondary";
  }
}

function getEstadoFromComprobante(historialcomprobante){
  let acreditada = historialcomprobante?.acreditada;
  let estado = historialcomprobante.estado;
  let mediopago = historialcomprobante.comprobante.medio_pago.slug

  if( (estado === "Aprobado" || acreditada ) && mediopago === "e-cheq" ){
    return "Aprobado";
  }else{
    return estado;
  }
}

</script>

<template>
  <div class="mt-3">
    <button
      class="btn btn-outline-primary  text-primary w-100 d-flex justify-content-between align-items-center btn-movimientos-garantias"
      type="button"
      @click="toggle"
      aria-expanded="show"
      aria-controls="tabla-movimientos-garantias"
    >
      <span class="fw-bold">Movimientos de garantías</span>
      <i :class="show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
    </button>

    <div
      v-if="show"
      class="card border-0 shadow-sm mt-2"
      id="tabla-movimientos-garantias"
    >
      <div class="card-body p-0">
        <div v-if="rows.length === 0" class="py-5 text-center text-muted">
          <i class="fa-regular fa-circle-xmark d-block fs-3 mb-2"></i>
          No existen movimientos
        </div>

        <div class="table-responsive" v-else>
          <table class="table table-sm align-middle table-clean mb-0">
            <thead>
              <tr class="text-center small text-muted">
                <th class="px-3 py-2 text-start">ID</th>
                <th class="px-3 py-2">Fecha</th>
                <th class="px-3 py-2">Monto</th>
                <th class="px-3 py-2">Tipo movimiento</th>
                <th class="px-3 py-2">Estado</th>
              </tr>
            </thead>

            <tbody class="text-center text-sm">
              <tr v-for="g in rows" :key="g.id">
                <td class="px-3 text-start fw-600">#{{ g.id }}</td>
                <td class="px-3">
                  {{ formatDateForBackend(g.created_at) }}
                </td>

                <td class="px-3 fw-bold" :class="sentidoClass(g)">
                  $ {{ signo(g) }}
                  {{ montoMostrado(g) }}
                </td>

                <td class="px-3">
                  <span
                    class="truncate"
                    :title="g.tipo_movimiento_garantia?.nombre || ''"
                  >
                    {{ g.tipo_movimiento_garantia?.nombre || "—" }}
                  </span>
                </td>
                <td class="px-3">
                  <span class="badge" :class="estadoBadgeClass(g.comprobantes_movimientos?.[0])">{{
                    getEstadoFromComprobante(g.comprobantes_movimientos?.[0])
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-clean th,
.table-clean td {
  vertical-align: middle;
  white-space: nowrap;
}

.table-clean thead th {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-weight: 600;
}

.table-clean tbody tr + tr {
  border-top: 1px solid #f1f3f5;
}

.truncate {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  white-space: nowrap;
}

.badge-soft {
  border-radius: 999px;
  padding: 0.35rem 0.6rem;
  font-weight: 600;
  font-size: 0.75rem;
}

.btn-movimientos-garantias {
  border-radius: 6px;
  border-width: 2px  !important;
  background: #fff;
  color: #006C4C;
}

.badge-soft.success {
  background: #e6f8ef;
  color: #0a7a3d;
}
.badge-soft.warning {
  background: #fff4e0;
  color: #a66b00;
}
.badge-soft.danger {
  background: #fde9ea;
  color: #b42318;
}
.badge-soft.secondary {
  background: #eef1f4;
  color: #475569;
}

@media (max-width: 576px) {
  .truncate {
    max-width: 140px;
  }
}
</style>
